import React from 'react';
import { Close } from '@mui/icons-material';

const ImageModal = ({ isShowImg, imgSrc, onClose }) => {
  if (!isShowImg) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-4 rounded-lg max-w-4xl w-full">
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
          onClick={onClose}
        >
          <Close fontSize="large" aria-label="Close" />
        </button>
        <div className="flex justify-center items-center">
          {imgSrc && <img src={URL.createObjectURL(imgSrc)} alt="Preview" className="max-w-full max-h-96" />}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
